import { ReactElement, useEffect, useRef } from 'react'
import { useFormContext } from 'react-hook-form'
import { InputAdornment, Stack } from '@mui/material'
import { TextField, ErrorField, UnitConvertedField } from '@ui/forms'

interface Props {
  onChange: (value: Interval, effective_height: number) => void
}

const StiffeningElementFormField = ({ onChange }: Props): ReactElement => {
  const { watch, setValue, formState } = useFormContext()
  const upper = watch('upper')
  const lower = watch('lower')
  const effective_height = watch('effective_height')
  const initialValue = useRef({ upper, lower, effective_height })

  useEffect(() => {
    onChange({ upper, lower }, effective_height)
    setValue('length', parseFloat((upper - lower).toFixed(3)))
  }, [upper, lower, effective_height])

  useEffect(() => {
    // all stiffening elments are saved at once so invalid
    // intervals have to be reset if user exits without saving
    return () => {
      if (!formState.isValid) {
        onChange(
          { lower: initialValue.current.lower, upper: initialValue.current.upper } as Interval,
          initialValue.current.effective_height,
        )
      }
    }
  }, [])

  return (
    <Stack spacing={1} direction="row">
      <TextField
        inputProps={{
          step: 0.1,
        }}
        inputLabel="Start"
        data-cy="input-element-start"
        name="lower"
        type="number"
        InputProps={{
          endAdornment: <InputAdornment position="end">m</InputAdornment>,
        }}
      />
      <TextField
        inputProps={{
          step: 0.1,
        }}
        inputLabel="Ende"
        name="upper"
        type="number"
        InputProps={{
          endAdornment: <InputAdornment position="end">m</InputAdornment>,
        }}
      />
      <TextField
        inputLabel="Länge (berechnet)"
        name="length"
        type="number"
        data-cy="input-element-length"
        disabled
        InputProps={{
          endAdornment: <InputAdornment position="end">m</InputAdornment>,
        }}
      />
      <UnitConvertedField
        inputLabel={'eff. Höhe'}
        tooltip={{ text: 'Für Nachweisführung und Ermittlung der Zugkräfte' }}
        tooltipOnInputLabel
        name="effective_height"
        conversionFactor={1}
        unitLabel="m"
      />
      <ErrorField data-cy="error-intersection" name="isIntersectingWithOpening" />
    </Stack>
  )
}

export default StiffeningElementFormField
